var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_266)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.13 0H6.32C2.82956 0 0 2.82956 0 6.32V15.13C0 18.6204 2.82956 21.45 6.32 21.45H15.13C18.6204 21.45 21.45 18.6204 21.45 15.13V6.32C21.45 2.82956 18.6204 0 15.13 0Z",
    fill: "url(#paint0_linear_1_266)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1816 14.7202V16.0402H14.2016L16.5116 13.6802V13.6602H15.2416C14.6616 13.6602 14.1816 14.1402 14.1816 14.7202Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4616 5.09008H9.48164C9.43164 5.09008 9.37164 5.09008 9.32164 5.10008C9.32164 5.10008 9.26164 5.11008 9.23164 5.12008C8.77164 5.23008 8.43164 5.65008 8.43164 6.14008V14.9801C8.43164 15.5401 8.87164 16.0001 9.42164 16.0301C9.44164 16.0301 9.46164 16.0301 9.48164 16.0301H13.8616V14.7101C13.8616 13.9501 14.4816 13.3201 15.2516 13.3201H16.5216V6.13008C16.5216 5.55008 16.0516 5.08008 15.4716 5.08008L15.4616 5.09008ZM15.5016 11.5901C15.5016 11.6901 15.4216 11.7701 15.3216 11.7701H9.62164C9.62164 11.7701 9.56164 11.7701 9.53164 11.7401C9.48164 11.7101 9.44164 11.6501 9.44164 11.5901V11.4601C9.44164 11.3601 9.52164 11.2801 9.62164 11.2801H15.3216C15.4216 11.2801 15.5016 11.3601 15.5016 11.4601V11.5901ZM15.5016 10.4301C15.5016 10.5301 15.4216 10.6101 15.3216 10.6101H9.62164C9.62164 10.6101 9.55164 10.6101 9.53164 10.5801C9.48164 10.5501 9.44164 10.4901 9.44164 10.4301V10.3001C9.44164 10.2001 9.52164 10.1201 9.62164 10.1201H15.3216C15.4216 10.1201 15.5016 10.2001 15.5016 10.3001V10.4301ZM15.5016 9.27008C15.5016 9.37008 15.4216 9.45008 15.3216 9.45008H9.62164C9.62164 9.45008 9.55164 9.45008 9.53164 9.42008C9.48164 9.39008 9.44164 9.33008 9.44164 9.27008V9.14008C9.44164 9.04008 9.52164 8.96008 9.62164 8.96008H15.3216C15.4216 8.96008 15.5016 9.04008 15.5016 9.14008V9.27008ZM15.5016 8.11008C15.5016 8.21008 15.4216 8.29008 15.3216 8.29008H9.62164C9.62164 8.29008 9.55164 8.29008 9.53164 8.26008C9.48164 8.23008 9.44164 8.17008 9.44164 8.11008V7.98008C9.44164 7.88008 9.52164 7.80008 9.62164 7.80008H15.3216C15.4216 7.80008 15.5016 7.88008 15.5016 7.98008V8.11008ZM15.5016 6.95008C15.5016 7.05008 15.4216 7.13008 15.3216 7.13008H9.62164C9.62164 7.13008 9.55164 7.12008 9.52164 7.10008C9.47164 7.07008 9.44164 7.01008 9.44164 6.95008V6.82008C9.44164 6.72008 9.52164 6.64008 9.62164 6.64008H15.3216C15.4216 6.64008 15.5016 6.72008 15.5016 6.82008V6.95008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.10094 14.9803V6.14027C8.10094 5.82027 8.21094 5.52027 8.40094 5.28027L5.78094 5.80027C5.22094 5.91027 4.86094 6.45027 4.97094 7.01027L6.66094 15.5203C6.77094 16.0803 7.31094 16.4403 7.87094 16.3303L8.76094 16.1503C8.36094 15.9103 8.09094 15.4703 8.09094 14.9703L8.10094 14.9803Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_266",
    x1: -19.95,
    y1: -8.39,
    x2: 39.03,
    y2: 28.37,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00DDB4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0090C7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_266"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.45,
    height: 21.45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenT);
export default __webpack_public_path__ + "static/media/openT.a50b0f899acd481686e015911061dd57.svg";
export { ForwardRef as ReactComponent };